import { ReactNode } from "react";
import classNames from "classnames";

type Props = {
  name: string;
  style?: string;
  label: ReactNode;
  requiredIcon?: boolean;
  marginBottom?: boolean;
};

export default function Label(props: Props) {
  const { name, label, style, requiredIcon, marginBottom = true } = props;

  return (
    <label
      htmlFor={name}
      className={classNames(
        "block text-xs font-medium text-gray-700",
        style ? style : "",
        marginBottom ? "mb-2" : ""
      )}
    >
      {label}
      {requiredIcon && (
        <span className="text-inherit text-red-400 ml-1">*</span>
      )}
    </label>
  );
}

export const labelModifier = (
  text: string,
  isRequired = false,
  isOptional = false,
  additionalText = ""
) => (
  <>
    {isRequired && <span className="text-[10px] text-red-500 mr-0.5">*</span>}
    {text}
    {isOptional && (
      <span className="text-gray-500 ml-0.5 text-[11px]">{"(optional)"}</span>
    )}
    {additionalText && (
      <span className="text-gray-500 ml-0.5 text-[11px]">{`(${additionalText})`}</span>
    )}
  </>
);
